/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Is_DisabledInputs */

const en_tables_users_is_disabled = /** @type {(inputs: Tables_Users_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Disabled`)
};

const de_tables_users_is_disabled = /** @type {(inputs: Tables_Users_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist deaktiviert`)
};

/**
* | output |
* | --- |
* | "Is Disabled" |
*
* @param {Tables_Users_Is_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_is_disabled = /** @type {((inputs?: Tables_Users_Is_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Is_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_is_disabled(inputs)
	return de_tables_users_is_disabled(inputs)
});